
import { EditorValidator, createDomElement } from "slickgrid-react";
import Contractor from ".";
import BaseGrid, { BasicGridProps } from "../../components/grid/BaseGridComponent";
import { State } from "../../components/grid/BasicGridState";
import { Link } from "react-router-dom";
import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server"
import authService from "../../services/auth/auth.service";

class ContractorFormatters{
    sender: BaseGrid;
    
    constructor(sender: any) {
        this.sender = sender  
     }

    

    cityFormatter = function (row: any, cell: any, value: any, columnDef: any, dataContext: any) {
        let s=""
        if ( dataContext.city != null){
          s ="<a class='slickRowLink' href='/contractors?city=" + dataContext.city + "' >" + dataContext.city + "</a>";
        }
        return s;
    };

    

    webpageFormatter = function (row: any, cell: any, value: any, columnDef: any, dataContext: any) {
        let s=""
        if ( dataContext.webpage !=null){
            if ((dataContext.webpage.toLowerCase().includes('http://')) ||  (dataContext.webpage.toLowerCase().includes('https://')) ){
              
              // s =  '<a target="_blank" class="slickRowLink webpagelink"  rel="noopener noreferrer" href="' +dataContext.webpage + '">'+dataContext.webpage+'</a>';
            
              const fragment = new DocumentFragment();
               const li = document.createElement("a");
               li.innerHTML = dataContext.webpage
               li.href = dataContext.webpage
               li.target="_blank"
               fragment.append(li)
               return fragment
            }else{
                let tmp = "http://" + dataContext.webpage
               // s =  '<a target="_blank" class="slickRowLink webpagelink"  rel="noopener noreferrer" href="' + tmp + '" >'+dataContext.webpage+'</a>';
               const fragment = new DocumentFragment();
               const li = document.createElement("a");
               li.innerHTML = dataContext.webpage
               li.href = tmp
               li.target="_blank"
               fragment.append(li)
               return fragment
            }    
        }
        return s;
    };

    
    handleClick = (e: any) => {
        e.preventDefault();
        console.log('The link was clicked.');
      };
    

    groupFormatter =  (row: any, cell: any, value: any, columnDef: any, dataContext: any) => {
        var s="";
        if (dataContext.group_names !=null){
            if (Array.isArray(dataContext.group_names)){
                s = dataContext.group_names.join(',');
            }else{
                var array = dataContext.group_names.split(',');
                
                for (var a in array ) {
                if (s!=""){
                    s+=", ";
                }	
                	
                s +="<a class='slickRowLink' href='/contractors?group_name=" +  array[a] + "' >" + array[a] + "</a>";
                
                }
            }
        
        }
         return s;
     };

     exportgroupFormatter =  (row: any, cell: any, value: any, columnDef: any, dataContext: any) => {
        var s="";
        if (dataContext.group_names !=null){
            if (Array.isArray(dataContext.group_names)){
                s = dataContext.group_names.join(',');
            }else{
                var array = dataContext.group_names.split(',');
                
                for (var a in array ) {
                if (s!=""){
                    s+=", ";
                }	
                	
                s +=array[a];
                
                }
            }
        
        }
         return s;
     };
    
     exportLabelsFormatter =  (row: any, cell: any, value: any, columnDef: any, dataContext: any) => {
        var s="";
        if (dataContext.labels_array !=null){
            if (Array.isArray(dataContext.labels_array)){
                s = dataContext.labels_array.join(',');
            }else{
                var array = dataContext.labels_array.split(',');
                
                for (var a in array ) {
                if (s!=""){
                    s+=", ";
                }	
                	
                s +=array[a];
                
                }
            }
        
        }
         return s;
     };
    

     labelFormatter =  (row: any, cell: any, value: any, columnDef: any, dataContext: any) => {
        var s="";

        if (dataContext.labels !=null){
            if (Array.isArray(dataContext.labels)){
                s = dataContext.labels.join(',');
            }else{
                var array = dataContext.labels.split(',');
                
                for (var a in array ) {
                if (s!=""){
                    s+=", ";
                }	
                s +="<a class='slickRowLink' href='/contractors?label=" +  array[a] + "' >" + array[a] + "</a>";
                
                }
            }
        
        }
         return s;
     };

     mailFormatter = function (row: any, cell: any, value: any, columnDef: any, dataContext: any) {
        var s=""
        if ( dataContext.mail !=null){
         s ="<a class='slickRowLink' href='mailto:" +  dataContext.mail + "' >" + dataContext.mail + "</a>";
        }
         return s;
     };

     pad2(number:number) {
   
        return (number < 10 ? '0' : '') + number
      
    }
   

	
     classificationFormatter =  (row: any, cell: any, value: any, columnDef: any, dataContext: any) => {
        var s="";
        if (dataContext.classifications !=null){
            if (Array.isArray(dataContext.classifications)){
                s = dataContext.classifications.join(',');
            }else{
                var array = dataContext.classifications.split(',');
                
                for (var a in array ) {
                if (s!=""){
                    s+=", ";
                }	
                	
                s +="<a class='slickRowLink' href='/contractors?classification=" +  array[a] + "' >" + array[a] + "</a>";
                
                }
            }
        
        }
         return s;
     };
     
}

export default ContractorFormatters